import React, { useEffect, useState } from 'react'
import "../../assets/css/style.css";
import { Modal } from 'react-bootstrap';
import Validation from '../../commonComponents/Validation';
import { changeUserPassword } from '../../services/apiProfile';
import ResponsePopup from '../../commonComponents/responseSucessPopup';
const ChangePassword = ({isChangePsw, handleClose}) => {
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmShowPassword] = useState(false);
  const [showOldPassword, setOldPassword] = useState(false);
  const [isSucess, SetSucess] = useState(false);
  const [ResponseMessage, SetResponseMessage] = useState("");
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [formData, setFormData] = useState({
    oldpassword: "",
    password: "",
    cpassword: ""
  });
useEffect(() => {
  if (!isChangePsw) {
    setFormData({
      oldpassword: "",
      password: "",
      cpassword: ""
    });
    setErrors({});
  }
}, [isChangePsw]);

 const UpdatePassword = async (event) => {
  event.preventDefault();
  if (!validateForm()) return;
  
  formData.userid = userData._id;
  
  try {
    let response = await changeUserPassword(formData);
    if (response.success === true) {
      // Clear the fields
      setFormData({
        oldpassword: "",
        password: "",
        cpassword: ""
      });
      
      // Close the modal first
      handleClose();
      
      // Then show success message after a small delay to ensure modal is closed
      setTimeout(() => {
        SetSucess(true);
        SetResponseMessage(response.message);
      }, 300);
    } 
    else {
      handleClose(); // Close modal even on failure if desired
      SetSucess(true);
      SetResponseMessage(response.message || "Failed to change password");
    }
  } catch (error) {
    console.error("Error changing password:", error);
    handleClose(); // Close modal on error
    SetSucess(true);
    SetResponseMessage("An error occurred while changing password");
  }
};

 function isValidPassword(pwd) {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(pwd);
    }

  const validateForm = () => {
    const newErrors = {};
    if (!formData.oldpassword) newErrors.oldpassword = true;
    if (!formData.password) newErrors.password = true;
    if (!formData.cpassword) newErrors.cpassword = true;
    if (formData.password !== formData.cpassword) newErrors.cpassword = "Passwords don't match";
    if (!isValidPassword(formData.password)) newErrors.password = "Password must include uppercase,lowercase,number,symbol and be at least 8 characters long";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
     setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };
   const togglePasswordVisibility = async(passwordType) => {
    if(passwordType === "new")
    setShowPassword(!showPassword);
     if(passwordType === "old")
    setOldPassword(!showOldPassword);
    if(passwordType === "confirm")
    setConfirmShowPassword(!showConfirmPassword);
   
  };

  return (
    <div>
      <Modal show={isChangePsw} onHide={handleClose} backdrop="static" keyboard={false} dialogClassName="small-custom-modal modal-dialog-centered">
        <Modal.Header closeButton>
          <div className="popupheader">
            <div className="header">
              <div className="signuup">Change Password</div>
              <p className="Stronger"></p>
            </div>
          </div>
        </Modal.Header>
        <form onSubmit={UpdatePassword}>
          <Modal.Body className='form-box shadow formboxwidth forgot-box'>
            <div className='forgot-btn'>
              <div className="position-relative mb-3">
                <input 
                  type={showOldPassword ? "text" : "password"}
                  name="oldpassword" 
                  className="form-control" 
                  placeholder="Current Password"
                  value={formData.oldpassword}
                  onChange={handleInputChange}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                />
              <i className={`bi ${showOldPassword ? 'bi-eye' : 'bi-eye-slash'} eye-icon password-icon`}
                  onClick={()=>togglePasswordVisibility('old')}
                  ></i>
              </div>
              <div> {errors.oldpassword && (
                  <Validation message={'Please Enter Old Password'} />
                )}</div>
              <div className="position-relative mb-3">
                <input 
                  type={showPassword ? "text" : "password"}
                  name="password" 
                  className="form-control" 
                  placeholder="New Password"
                  value={formData.password}
                  onChange={handleInputChange}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                />
                <i className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'} eye-icon password-icon`}
                  onClick={()=>togglePasswordVisibility('new')}
                  ></i>
             
              </div>
              <div>{errors.password && typeof errors.password !== 'string' && (
                  <Validation message={'Please Enter New Password'} />
                )}
               {errors.password && typeof errors.password === 'string' && (
                  <Validation message={errors.password} />
                )}
                </div>
              <div className="position-relative mb-0">
                <input 
                   type={showConfirmPassword? "text" : "password"}
                  className="form-control" 
                  name="cpassword" 
                  placeholder="Confirm New Password"
                  value={formData.cpassword}
                  onChange={handleInputChange}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                />
                <i className={`bi ${showConfirmPassword ? 'bi-eye' : 'bi-eye-slash'} eye-icon password-icon`}
                  onClick={()=>togglePasswordVisibility('confirm')}
                  ></i>
                  
              </div>
              <div>
                {errors.cpassword && typeof errors.cpassword === 'string' && (
                  <Validation message={errors.cpassword} />
                )}
                </div>
              <div className='bottom-buttons'>
                <button type="submit" className="btn text-dark reset-btn">
                  OK
                </button>
                <button type="button" className="btn text-dark logbtn" onClick={handleClose}>
                  Cancel
                </button>
              </div>
            </div>
          </Modal.Body>
        </form>
      </Modal>
       {isSucess && (<ResponsePopup
              isSucess={isSucess}
              CancelPopup={() => {
                SetSucess(false);
              }}
              message={ResponseMessage}
            />)}
    </div>
  )
}

export default ChangePassword